export default "__VITE_ASSET__CPZJ3iWb__"